const home: Record<string, string> = {
  "hero.badge": "CSSBuy Spreadsheet 2026",
  "hero.title1": "CSSBuy Spreadsheet",
  "hero.title2": "O Guia Definitivo para Compras",
  "hero.description": "Aceda às planilhas mais completas de sellers CSSBuy. Encontre os melhores vendedores de sneakers, roupas, acessórios e muito mais. Listas atualizadas semanalmente com ratings verificados pela comunidade.",
  "about.label": "Sobre Nós",
  "about.title1": "A Sua Fonte Confiável de",
  "about.title2": "Informação sobre CSSBuy",
  "about.title3": "Spreadsheets & Sellers",
  "about.description": "Mantemos as listas mais atualizadas de sellers CSSBuy verificados pela comunidade, com ratings de confiança e velocidade de envio.",
  "about.review.text": "Excelente recurso para encontrar vendedores confiáveis. As planilhas são atualizadas regularmente e a organização por categorias torna tudo muito fácil de navegar. Recomendo a todos que usam CSSBuy.",
  "about.review.name": "Marcos Silva",
  "about.review.role": "Comprador Verificado",
  "categories.title1": "Encontre os Melhores Sellers",
  "categories.title2": "por Categoria",
  "categories.subtitle": "Categorias de Produtos",
  "articles.title1": "Artigos & Guias SEO",
  "articles.title2": "Conteúdo Original Atualizado",
  "testimonials.label": "Depoimentos Verificados",
  "testimonials.quote": "As planilhas do CSSBuy Spreadsheet mudaram completamente a minha experiência de compra. Encontrei sellers incríveis que nunca teria descoberto sozinho. Interface limpa e informações sempre atualizadas.",
  "testimonials.name": "Ana Oliveira",
  "testimonials.platform": "Trustpilot",
  "newsletter.title": "Fique Atualizado",
  "newsletter.description": "Receba as últimas atualizações de sellers e novos guias diretamente no seu e-mail.",
};

export default home;